import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UrlConfig } from './../../../config/url-config';
import { NavigationService } from '../../services/navigation.service';
import { finalize, Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { UserProfileRecord } from 'app/users/user-profile-record';
import { UserService } from 'app/users/user.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { FormService } from 'app/services/form.service';
import { UnlockCaseModel } from 'app/models/unlock-case.model';
import { AdminService } from 'app/services/admin.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
  mainNavVisible = false;
  userNavVisible = false;
  mainNavActive = false;
  userNavActive = false;
  sideNavOpened: boolean = true;
  private user!: UserProfileRecord;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;
  
  ngOnInit(): void {
    this.user = this.userService.profile;
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if(result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.sizeChangeSubscription.unsubscribe();
  }

  public switchRoles() {
    this.userService.profile.userRole = undefined;
    this.router.navigate(['/usan']);
  }

  public logOut() {
    var unlockModel;

    if(this.formService.getCurrentUsanFormValue()?.get('caseSysId')?.value) {
      unlockModel = UnlockCaseModel.parseFormGroup(this.formService.getCurrentUsanFormValue());
    } else if(this.adminService.getCurrentApplicationCaseSysId()) {
      unlockModel = UnlockCaseModel.parseValues(
        { 
          caseSysId: this.adminService.getCurrentApplicationCaseSysId(),
          lockedById: this.userService.profile.uniqueId ?? ''
        }
      );
    }
    
    if(!unlockModel?.caseSysId) {
      window.location.href = this.logoutUrl;
      return;
    }

    this.formService.unlockCase(unlockModel)
      .subscribe({
        next: (response) => {
          // Ensure the external URL is returned before redirecting
          if (response) {
            window.location.href = this.logoutUrl;
          }
        },
          error: (err) => {
            console.error(err);
            if(err) {
              window.location.href = this.logoutUrl;
            }
          }
      });
  }

  get amaWireUrl(): string {
    return this.links.amaWire;
  }

  get amaStoreUrl(): string {
    return this.links.amaStore;
  }

  get jamaUrl(): string {
    return this.links.jama;
  }

  get journalOfEthicsUrl(): string {
    return this.links.journalOfEthics;
  }

  get accountManagementCenterUrl(): string {
    return environment.accountManagementCenter;
  }

  get amaStoreAccount(): string {
    return this.links.amaStoreAccount;
  }

  get joinRenewUrl(): string {
    return this.links.joinRenew;
  }

  get loginUrl(): string {
    return this.withRedirect(this.links.login);
  }

  get logoutUrl(): string {
    return this.withRedirect(environment.logout);
  }

  get createAccountUrl(): string {
    return this.withRedirect(this.links.createAccount);
  }

  get displayName() {
    return this.user?.displayName;
  }

  constructor(
    protected formService: FormService,
    private adminService: AdminService,
    protected userService: UserService, 
    private links: UrlConfig, 
    private navigationService: NavigationService, 
    private responsive: BreakpointObserver,
    private router: Router
  ) {
    this.sendOpenedMessage();
  }

  private withRedirect(url: string) {
    return `${url}?returnurl=${encodeURIComponent(environment.usan)}`;
  }

  public toggleOpened() {
    // Skip if on mobile device or in a smaller window.
    if (this.isMobileDeviceSize)
      return;
    this.sideNavOpened = !this.sideNavOpened;
    this.sendOpenedMessage();
  }

  public sendOpenedMessage() {
    this.navigationService.sendSideNavOpenedUpdate(this.sideNavOpened);
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }

  get canUserSwitchRoles(): boolean {
    return this.user?.availableRoles ? this.user.availableRoles.length > 1 : false;
  }

}
